import { Button, Checkbox, Col, Divider, Radio, Row } from 'antd'
import React, { useState } from 'react'
import IntlMessages from 'util/IntlMessages'

import bkash from '../../../assets/images/payment/bkash_logo.svg'
import nagad from '../../../assets/images/payment/nagad_logo.svg'
import ssl from '../../../assets/images/payment/sslcommerz_pgw_logo.svg'

const RadioGroup = Radio.Group

const ZakatPaymentMethod = ({ paymentInfo, submitFunction }) => {
	const { amount, ...rest } = paymentInfo
	const [selectedMethod, setSelectedMethod] = useState(null)
	const [paymentMethodError, setPaymentMethodError] = useState(false)
	const [gatewayFee, setGatewayFee] = useState(0)
	const [agreeToGiveGatewayFee, setAgreeToGiveGatewayFee] = useState(false)

	const gatewayFeeAgreementHandler = () => {
		if (agreeToGiveGatewayFee) {
			setAgreeToGiveGatewayFee(false)
		} else if (!agreeToGiveGatewayFee) {
			setAgreeToGiveGatewayFee(true)
		}
	}

	const selectPaymentMethod = value => {
		setSelectedMethod(value)
		setPaymentMethodError(false)
	}

	const donateHandler = () => {
		const donationData = {
			...rest,
			amount: agreeToGiveGatewayFee ? amount + parseFloat(gatewayFee) : amount,
			gateway: selectedMethod
		}
		if (!selectedMethod) {
			setPaymentMethodError(true)
		} else {
			submitFunction(donationData)
		}
	}

	return (
		<div>
			<h1>
				<p>
					<IntlMessages id='payment.method.title' />
				</p>
			</h1>
			<p style={{ paddingBottom: 10 }}>
				<IntlMessages id='payment.method.desc' />
			</p>

			<RadioGroup
				buttonStyle='solid'
				size='large'
				style={{
					flexDirection: 'column',
					width: '100%',
					paddingBottom: 10
				}}
			>
				<Row gutter={16}>
					<Col lg={12} md={12} sm={24} xs={24}>
						<Radio
							value='bkash'
							onChange={() => {
								const fee = parseFloat(((amount * 1.55) / 100).toFixed(2))
								selectPaymentMethod('bkash')
								setGatewayFee(fee)
							}}
							button
							style={{
								width: '100%',
								height: 85,
								paddingTop: 5,
								paddingLeft: 15,
								marginBottom: 16,
								border:
									selectedMethod === 'bkash'
										? '1px solid #018E49'
										: '1px solid #DBDBDB',
								background:
									selectedMethod === 'bkash' ? '#E4FFF2' : 'transparent',
								borderRadius: '4px'
							}}
						>
							<img src={bkash} alt='bkash payment' />
							<p>
								<IntlMessages id='payment.method.option.bkash' />
							</p>
						</Radio>
					</Col>
					{/* Nogod Implemented Here */}

					<Col lg={12} md={12} sm={24} xs={24}>
						<Radio
							value='nagad'
							onChange={() => {
								const fee = parseFloat(((amount * 1.03) / 100).toFixed(2))
								selectPaymentMethod('nagad')
								setGatewayFee(fee)
							}}
							style={{
								width: '100%',
								height: 85,
								paddingTop: 5,
								paddingLeft: 15,
								marginBottom: 16,
								border:
									selectedMethod === 'nagad'
										? '1px solid #018E49'
										: '1px solid #DBDBDB',
								background:
									selectedMethod === 'nagad' ? '#E4FFF2' : 'transparent',
								borderRadius: '4px'
							}}
						>
							<img src={nagad} alt='nagad payment' />
							<p>
								<IntlMessages id='payment.method.option.nogod' />
							</p>
						</Radio>
					</Col>
					<Col xl={12} lg={24} md={24} sm={24} xs={24}>
						<Radio
							value='sslcommerz'
							onChange={() => {
								const fee = parseFloat(((amount * 2.25) / 100).toFixed(2))
								selectPaymentMethod('sslcommerz')
								setGatewayFee(fee)
							}}
							checked={selectedMethod === 'sslcommerz'}
							style={{
								width: '100%',
								height: 85,
								paddingTop: 10,
								paddingLeft: 15,
								border:
									selectedMethod === 'sslcommerz'
										? '1px solid #018E49'
										: '1px solid #DBDBDB',
								background:
									selectedMethod === 'sslcommerz' ? '#E4FFF2' : 'transparent',
								borderRadius: '4px'
							}}
						>
							<img
								src={ssl}
								alt='ssl-payment'
								style={{ marginBottom: '4px' }}
							/>
							<p>
								<IntlMessages id='payment.method.option.ssl' />
							</p>
						</Radio>
					</Col>
				</Row>
			</RadioGroup>

			<Row
				gutter={0}
				justify='end'
				style={{ marginBottom: '12px', padding: '0 16px' }}
			>
				<Col xs={24} style={{ padding: 0 }}>
					<div
						style={{
							// width: '50%',
							borderRadius: '4px',
							border: '1px solid #DBDBDB',
							background: '#FAFAFA',
							fontSize: '16px',
							padding: '5px 0px 5px'
						}}
					>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								color: '#545454',
								padding: '0 15px',
								boxSizing: 'border-box'
							}}
						>
							<p style={{ margin: 0 }}>
								<IntlMessages id='payment.method.summary.amount' />:
							</p>
							<p style={{ margin: 0 }}>{amount} ৳</p>
						</div>

						<Divider dashed />

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								color: '#545454',
								padding: '0 15px'
							}}
						>
							<p style={{ margin: 0 }}>
								<IntlMessages id='payment.method.summary.gateway.fee' />:
							</p>
							<p style={{ margin: 0 }}>
								{agreeToGiveGatewayFee ? gatewayFee : 0} ৳
							</p>
						</div>
						<Divider />

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								color: '#545454',
								padding: '0 15px'
							}}
						>
							<p style={{ margin: 0 }}>
								<IntlMessages id='payment.method.summary.total.amount' />:
							</p>
							<p style={{ margin: 0 }}>
								{agreeToGiveGatewayFee
									? amount + parseFloat(gatewayFee)
									: amount}{' '}
								৳
							</p>
						</div>

						<Divider dashed />

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								color: '#008F47',
								padding: '0 15px'
							}}
						>
							<p style={{ margin: 0 }}>
								<IntlMessages id='payment.method.summary.total.zakat.amount' />:
							</p>
							<p style={{ margin: 0 }}>
								{agreeToGiveGatewayFee
									? amount
									: (amount - parseFloat(gatewayFee)).toFixed(2)}{' '}
								৳
							</p>
						</div>
					</div>
				</Col>
			</Row>

			<div
				style={{
					marginBottom: 12
				}}
			>
				<p>
					<IntlMessages id='payment.method.gateway.fee.agreement' />
				</p>
				<Checkbox
					onChange={gatewayFeeAgreementHandler}
					checked={agreeToGiveGatewayFee}
				>
					<IntlMessages id='payment.method.gateway.fee.agreement.checkbox' />
				</Checkbox>
			</div>
			<div style={{ display: 'flex', justifyContent: 'end' }}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '50%'
					}}
				>
					{paymentMethodError && (
						<p style={{ color: 'red' }}>
							<IntlMessages id='payment.method.error.text' />
						</p>
					)}
					<Button
						type='primary'
						htmlType='button'
						style={{ width: '100%' }}
						onClick={donateHandler}
					>
						<IntlMessages id='payment.info.donateButton' />
					</Button>
				</div>
			</div>
			<p style={{ textAlign: 'center' }}>
				<IntlMessages id='payment.agree.1' />
				<a href='/terms-and-condition'>
					<IntlMessages id='payment.terms' />
				</a>
				<IntlMessages id='payment.agree.2' />
				<a href='/privacy-policy'>
					<IntlMessages id='payment.privacy' />
				</a>
				<IntlMessages id='payment.agree.3' />
			</p>
		</div>
	)
}

export default ZakatPaymentMethod
